/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IViewDiscount, IViewDiscountInterface } from "../IViewDiscount";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "requester",
        type: "address",
      },
    ],
    name: "viewDiscount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IViewDiscount__factory {
  static readonly abi = _abi;
  static createInterface(): IViewDiscountInterface {
    return new utils.Interface(_abi) as IViewDiscountInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IViewDiscount {
    return new Contract(address, _abi, signerOrProvider) as IViewDiscount;
  }
}
